var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockArrowBackLightBlueWhiteBgRoundedLightBlueBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3.5,
    stroke: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0913 9.07837C17.7737 8.83562 19.4865 9.16045 20.9711 10.0021C22.4553 10.8436 23.6295 12.1551 24.3198 13.7362C25.0101 15.317 25.1804 17.084 24.8059 18.7716C24.4314 20.4594 23.5316 21.9796 22.2386 23.1016C20.9454 24.2239 19.3291 24.8866 17.6329 24.9867C15.9367 25.0868 14.2561 24.6187 12.8448 23.6552C11.4337 22.692 10.3691 21.2867 9.80804 19.6534C9.68841 19.3052 9.87372 18.926 10.2219 18.8063C10.5702 18.6867 10.9494 18.872 11.069 19.2202C11.5383 20.5861 12.4265 21.7553 13.5965 22.554C14.7662 23.3525 16.1552 23.7383 17.5544 23.6557C18.9536 23.5731 20.291 23.0263 21.3647 22.0946C22.4387 21.1626 23.1908 19.8956 23.5042 18.4828C23.8177 17.0699 23.6748 15.591 23.0979 14.2697C22.5211 12.9486 21.5427 11.8589 20.3135 11.162C19.0845 10.4653 17.6698 10.1978 16.2817 10.398C15.0304 10.5786 14.2137 11.3955 12.8709 12.7386C12.8539 12.7555 12.8369 12.7726 12.8197 12.7897L11.1417 14.6961H13C13.3682 14.6961 13.6667 14.9946 13.6667 15.3628C13.6667 15.731 13.3682 16.0294 13 16.0294H9.66667C9.29848 16.0294 9 15.731 9 15.3628V11.8928C9 11.5247 9.29848 11.2262 9.66667 11.2262C10.0349 11.2262 10.3333 11.5247 10.3333 11.8928V13.5964L11.8329 11.8928C11.8423 11.8822 11.8519 11.8719 11.8619 11.8619C11.9316 11.7923 12.0009 11.7227 12.0699 11.6535C13.2725 10.446 14.3903 9.32381 16.0913 9.07837ZM17.0509 13C17.4191 13 17.7175 13.2985 17.7175 13.6667V17.2559L19.9988 18.4045C20.3277 18.5701 20.4601 18.9709 20.2945 19.2998C20.1289 19.6287 19.7281 19.761 19.3992 19.5955L16.7511 18.2621C16.5261 18.1489 16.3842 17.9185 16.3842 17.6667V13.6667C16.3842 13.2985 16.6827 13 17.0509 13Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockArrowBackLightBlueWhiteBgRoundedLightBlueBorder);
export default __webpack_public_path__ + "static/media/clockArrowBackLightBlueWhiteBgRoundedLightBlueBorder.503b749305aad4fcdcc2a45697235c46.svg";
export { ForwardRef as ReactComponent };